export default __webpack_public_path__ + "static/media/planeAsset 1.dcf8d071.svg";